import clsx from "clsx";
import React, { ReactNode } from "react";

interface LinkProps {
    [key: string]: any;
    children: ReactNode;
    url: string;
    className?: string;
}

export const Link = ({ children, url, className, ...props }: LinkProps) => {
    return (
        <a className={clsx(className, "mx-1 hover:cursor-pointer")} href={url} {...props} rel="noreferrer">
            {children}
        </a>
    );
};
